import React from 'react';
import './Hero.css';
import heroImage from '../assets/hero.jpg';

const Hero: React.FC = () => {
  const scrollToRegistration = () => {
    const element = document.getElementById('registration');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      className="hero"
      id="hero"
      style={{
        backgroundImage: `url(${heroImage})`
      }}
    >
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <div className="section-header">
            <h1 className="hero-title">San Mateo's Premier Orthodontist</h1>
            <p className="hero-subtitle">
              Dr. Tom Ellerhorst, Board Certified Orthodontist, has been transforming smiles
              in San Mateo for over a decade. Local expertise. Advanced technology.
              Exceptional results.
            </p>
          </div>
          <div className="hero-cta">
            <button
              className="cta-button primary hero-cta-button"
              onClick={scrollToRegistration}
              aria-label="Start your orthodontic journey"
            >
              Get Your Perfect Smile
            </button>
            <p className="hero-cta-note">
              ✓ Board Certified • ✓ Local San Mateo Expert • ✓ Braces & Invisalign
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 